import {
  useState, useLayoutEffect, useCallback, useMemo,
} from 'react';
import { debounce } from '@/utils/debounce';

const useResize = () => {
  const [rect, setRect] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleResize = useCallback(() => {
    setRect({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, []);

  const onResize = useMemo(
    () => debounce(handleResize, 100),
    [handleResize],
  );

  useLayoutEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);

  return rect;
};

export default useResize;
